import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-right-bar', 'IconArrowRightBar', [
  ['path', { d: 'M18 15l3 -3l-3 -3', key: 'svg-0' }],
  ['path', { d: 'M3 12h18', key: 'svg-1' }],
  ['path', { d: 'M3 9v6', key: 'svg-2' }],
]);
